/* Personalizer v3 step-content renderers: count cards, per-bestie SVG type
   cards, swatch rows + charm notes, and the one-row cartoon tote mockups.
   Attaches onto window.PersonalizerRender (created by personalizer-render.js,
   which loads first). All data comes from the JSON embed via ctx.config. */
(function () {
  'use strict';

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function money(ctx, cents) {
    return window.PersonalizerCart.formatMoney(cents, ctx.config.moneyFormat);
  }

  /* Display noun for one personalized unit — "Bestie" (default) or e.g. "Pet".
     UI-only: cart property KEYS always stay "Bestie i" (fulfillment contract). */
  function unitOf(ctx) { return ctx.config.unitLabel || 'Bestie'; }

  /* Compact display name: "The Full Set" → "Full Set", "Just the Tote" → "Tote". */
  function shortLabel(def) {
    return (def.label || def.key).replace(/^(The|Just the)\s+/i, '');
  }

  /* Card drawing per type, via the <use> symbols defined in the embed.
     Pet products (unitLabel "Pet") draw the floppy-eared pup instead of the
     human doll — same slots, more literal. */
  function typeSvg(ctx, def) {
    var dollId = unitOf(ctx).toLowerCase() === 'pet' ? '#personalizer-ic-pet' : '#personalizer-ic-doll';
    var tote = '<use href="#personalizer-ic-tote"></use>';
    var doll = '<use href="' + dollId + '"></use>';
    var inner;
    if (def.key === 'full') {
      inner = '<use href="#personalizer-ic-tote" x="-2"></use><g transform="translate(24,6) scale(.62)">' + doll + '</g>';
    } else if (def.needsColor) {
      inner = tote; // tote-style types
    } else {
      inner = doll; // charm-style types
    }
    return '<svg viewBox="0 0 60 52" aria-hidden="true" focusable="false">' + inner + '</svg>';
  }

  /* The cartoon tote lives in personalizer-bag-art.js so the colour mockups
     and the step-1 drawings are literally the same bag. */
  function toteSvg(hex) {
    return window.PersonalizerBagArt.toteSvg(hex);
  }

  /* Hex of the colour already chosen for the bag, if any — step 1 redraws in
     it when the customer walks back, so the two steps agree. */
  function pickedHex(ctx) {
    var bag = ctx.state.besties[0];
    var hex = null;
    if (bag && bag.color) {
      (ctx.config.palettes || []).forEach(function (p) { if (p.name === bag.color) hex = p.hex; });
    }
    return hex;
  }

  /* Caption pill text colour by background luminance (dark text on light fills). */
  function pillTextColor(hex) {
    var c = String(hex).replace('#', '');
    var r = parseInt(c.slice(0, 2), 16);
    var g = parseInt(c.slice(2, 4), 16);
    var b = parseInt(c.slice(4, 6), 16);
    return (r * 299 + g * 587 + b * 114) / 1000 > 150 ? '#222' : '#fff';
  }

  /* oneBag step 1 header: order-level type cards ("What would you like?") —
     Full Set (ribbon + strike) / Just the Tote / Just the Dolls. Prices are
     the solo combo prices; clicking routes through ctx.setOrderType which
     re-derives everything downstream (counts, colours, names, steps). */
  function renderOrderType(ctx) {
    var mount = ctx.root.querySelector('[data-personalizer-order-type]');
    if (!mount) return;
    var types = ctx.config.types || [];
    if (ctx.config.bagMode !== 'oneBag' || types.length < 2) {
      mount.innerHTML = '';
      mount.hidden = true;
      return;
    }
    mount.hidden = false;
    mount.innerHTML = '';
    var q = document.createElement('div');
    q.className = 'personalizer__q';
    q.textContent = ctx.config.typeQuestion || 'What would you like?';
    mount.appendChild(q);
    var grid = document.createElement('div');
    grid.className = 'personalizer__types';
    grid.setAttribute('role', 'radiogroup');
    grid.setAttribute('aria-label', q.textContent);
    var current = ctx.state.orderType || 'full';
    types.forEach(function (def) {
      var sel = current === def.key;
      var card = document.createElement('button');
      card.type = 'button';
      card.className = 'personalizer__tcard' + (sel ? ' personalizer__tcard--sel' : '');
      card.setAttribute('role', 'radio');
      card.setAttribute('aria-checked', sel ? 'true' : 'false');
      var priceC = window.PersonalizerCart.typePriceCents(ctx.config, def.key);
      var compareC = Math.round(parseFloat(def.compareAt) * 100) || 0;
      card.innerHTML = (def.badge ? '<span class="personalizer__ribbon">' + esc(def.badge) + '</span>' : '')
        + typeSvg(ctx, def)
        + '<div class="personalizer__tcard-nm">' + esc(shortLabel(def)) + '</div>'
        + '<div class="personalizer__tcard-pr">' + esc(money(ctx, priceC))
        + (compareC ? '<span class="personalizer__tcard-was">' + esc(money(ctx, compareC)) + '</span>' : '')
        + '</div>';
      card.addEventListener('click', function () {
        if (ctx.state.orderType !== def.key) ctx.setOrderType(def.key);
      });
      grid.appendChild(card);
    });
    mount.appendChild(grid);
    updateCountHint(ctx);
    updateCountQuestion(ctx);
  }

  /* Explainer under the count question — per order type when configured
     (config.typeHints[orderType]), else the static config.countHint. */
  function updateCountHint(ctx) {
    var ot = ctx.state.orderType || 'full';
    var txt = (ctx.config.typeHints && ctx.config.typeHints[ot]) || ctx.config.countHint || '';
    // Bag products show this line twice — under the type cards, where it
    // explains the choice just made, and again on the count page, where it
    // explains what one more pet actually buys.
    ctx.root.querySelectorAll('[data-personalizer-count-hint]').forEach(function (el) {
      el.textContent = txt;
      el.hidden = !txt;
    });
  }

  /* The count question itself also follows the order type — dolls-only must
     not ask "on your bag" (config.countQuestions[orderType]). */
  function updateCountQuestion(ctx) {
    var el = ctx.root.querySelector('[data-personalizer-count-q]');
    if (!el) return;
    var ot = ctx.state.orderType || 'full';
    var txt = (ctx.config.countQuestions && ctx.config.countQuestions[ot]) || ctx.config.countQuestion;
    if (txt) el.textContent = txt;
  }

  /* Step 1 size preview — countAxis.preview === 'scale' + config.sizeGuide.
     Jellycat's "How big am I?" composition, inline and drawn, with a camera
     that zooms per size: the doll art fills most of the frame, while two
     fixed real-world references stand beside it at the SAME zoom — the 6×4″
     photo card that ships with every doll (behind-right) and a typical 6″
     phone (right). The zoom is capped so the phone always fits, which is
     exactly what makes a 4″ doll read as "shorter than a phone". A dimension
     line on the doll's left reads the height in cm/in; the size pills
     underneath (with prices) are the control. Re-renders for the same lineup
     update in place so the zoom transitions play. Returns false when no
     variant name carries an inch number, so renderAxis falls back to pills. */
  var PV_W = 300, PV_H = 230, PV_BASE = 194;   // viewBox; feet baseline
  var PV_DOLL_MAX = 150;                         // doll height target in viewBox units
  var PV_DOLL_X = 96;                            // doll centre
  var PV_PHONE_IN = 6, PV_PHONE_W = 29, PV_PHONE_H = 60; // the #pz-sg-phone sprite, 6″ tall at 10 units/inch
  /* Units per inch for one doll of this height: capped by the doll's target
     height, the phone fitting under the title, the row doll→card→phone
     fitting the width, and label room on the left. The "how many" step draws
     its single doll at this very zoom, so the two frames agree. */
  function pvZoom(inches, cardW) {
    return Math.min(
      PV_DOLL_MAX / inches,
      (PV_BASE - 40) / PV_PHONE_H * 10,
      (PV_W - 14 - PV_DOLL_X + 24 - 10) / (0.26 * inches + cardW + PV_PHONE_W / 10),
      (PV_DOLL_X - 40) / (0.26 * inches + 0.3)
    );
  }
  function renderSizePreview(ctx, mount, values, axisCfg) {
    var sg = ctx.config.sizeGuide;
    var cardW = (sg.card && sg.card.w) || 6, cardH = (sg.card && sg.card.h) || 4; // inches
    var inchesOf = function (s) { var m = /(\d+(?:\.\d+)?)/.exec(String(s || '')); return m ? parseFloat(m[1]) : null; };
    var byInch = {};
    (sg.items || []).forEach(function (it) { byInch[it.inches] = it; });
    var sizes = [];
    values.forEach(function (val) {
      var inches = inchesOf(val.name);
      if (inches === null) return;
      var it = byInch[inches] || {};
      var v1 = window.PersonalizerCart.countVariant(ctx.config, 1, val.name);
      sizes.push({ val: val, inches: inches, cm: it.cm || Math.round(inches * 2.54) + ' cm', price: v1 ? money(ctx, v1.price) : '' });
    });
    if (!sizes.length) return false;
    var sig = values.map(function (v) { return v.name + (v.soldOut ? '!' : ''); }).join('|');
    var selected = null;
    sizes.forEach(function (s) { if (ctx.state.axis === s.val.name) selected = s; });

    var wrap = mount.querySelector('[data-sizepv-sig]');
    if (!wrap || wrap.getAttribute('data-sizepv-sig') !== sig) {
      mount.innerHTML = '';
      var q = document.createElement('div');
      q.className = 'personalizer__q';
      q.textContent = axisCfg.label || 'Choose the size';
      mount.appendChild(q);
      wrap = document.createElement('div');
      wrap.className = 'personalizer__sizepv';
      wrap.setAttribute('data-sizepv-sig', sig);
      var fig = document.createElement('div');
      fig.className = 'personalizer__sizepv-fig';
      fig.innerHTML =
        '<svg viewBox="0 0 ' + PV_W + ' ' + PV_H + '" aria-hidden="true" focusable="false">' +
          '<text class="personalizer__sizepv-title" data-sizepv-title x="14" y="22"></text>' +
          '<line class="personalizer__sizepv-floor" x1="16" x2="' + (PV_W - 16) + '" y1="' + PV_BASE + '" y2="' + PV_BASE + '"/>' +
          '<g class="personalizer__sizepv-ref" data-sizepv-card><use href="#pz-sg-card" xlink:href="#pz-sg-card"></use></g>' +
          '<text class="personalizer__sizepv-reflbl" data-sizepv-cardlbl1 y="' + (PV_BASE + 13) + '" text-anchor="middle">' + ((sg.card && sg.card.label) ? sg.card.label.toLowerCase() : 'photo card') + '</text>' +
          '<text class="personalizer__sizepv-reflbl" data-sizepv-cardlbl2 y="' + (PV_BASE + 24) + '" text-anchor="middle">' + cardW + ' × ' + cardH + ' in · included</text>' +
          '<g class="personalizer__sizepv-ref" data-sizepv-phone><use href="#pz-sg-phone" xlink:href="#pz-sg-phone"></use></g>' +
          '<text class="personalizer__sizepv-reflbl" data-sizepv-phonelbl1 y="' + (PV_BASE + 13) + '" text-anchor="middle">typical phone</text>' +
          '<text class="personalizer__sizepv-reflbl" data-sizepv-phonelbl2 y="' + (PV_BASE + 24) + '" text-anchor="middle">' + PV_PHONE_IN + ' in · 15 cm</text>' +
          '<g class="personalizer__sizepv-doll" data-sizepv-doll><use href="#pz-sg-doll" xlink:href="#pz-sg-doll" transform="translate(-26,-100)"></use></g>' +
          '<g class="personalizer__sizepv-dim" data-sizepv-dim>' +
            '<rect class="personalizer__sizepv-dimv" data-sizepv-dimv x="-0.7" y="' + PV_BASE + '" width="1.4" height="0"/>' +
            '<rect class="personalizer__sizepv-dimcap" x="-5" y="' + (PV_BASE - 0.7) + '" width="10" height="1.4"/>' +
            '<rect class="personalizer__sizepv-dimcap" data-sizepv-dimtop x="-5" y="' + (PV_BASE - 0.7) + '" width="10" height="1.4"/>' +
            '<text class="personalizer__sizepv-dimcm" data-sizepv-dimcm x="-8" y="0" text-anchor="end"></text>' +
            '<text class="personalizer__sizepv-dimin" data-sizepv-dimin x="-8" y="0" text-anchor="end"></text>' +
          '</g>' +
        '</svg>';
      wrap.appendChild(fig);
      var row = document.createElement('div');
      row.className = 'personalizer__axis personalizer__axis--sizepv';
      row.setAttribute('role', 'radiogroup');
      row.setAttribute('aria-label', q.textContent);
      var tagged = false;
      sizes.forEach(function (s) {
        var p = buildAxisPill(ctx, s.val);
        if (p.getAttribute('data-tagged')) tagged = true;
        // price per size, like Apple's case-size cards — placed before the tag line
        if (s.price && !s.val.soldOut) {
          var pr = document.createElement('span');
          pr.className = 'personalizer__axis-price';
          pr.textContent = s.price;
          var tagEl = p.querySelector('.personalizer__axis-tag');
          if (tagEl) p.insertBefore(pr, tagEl); else p.appendChild(pr);
        }
        row.appendChild(p);
      });
      if (tagged) row.classList.add('personalizer__axis--tagged');
      wrap.appendChild(row);
      mount.appendChild(wrap);
    }

    // --- camera: units per inch for this size -------------------------------
    var inches = selected ? selected.inches : 0;
    var k = inches > 0 ? pvZoom(inches, cardW) : 10;
    var h = inches * k;                     // doll height in units
    var s = h / 100;                        // the doll sprite is 100 units tall
    var ref = k / 10;                       // card + phone sprites are drawn at 10 units/inch
    var cardLeft = PV_DOLL_X + 0.26 * h - 24;
    var cardTop = PV_BASE - cardH * k;
    var cardCx = cardLeft + cardW * k / 2;
    var phoneLeft = cardLeft + cardW * k + 10;
    var phoneTop = PV_BASE - PV_PHONE_H * ref;
    var phoneCx = phoneLeft + PV_PHONE_W * ref / 2;

    var card = wrap.querySelector('[data-sizepv-card]');
    card.style.transform = 'translate(' + cardLeft.toFixed(1) + 'px,' + cardTop.toFixed(1) + 'px) scale(' + ref.toFixed(4) + ')';
    var phone = wrap.querySelector('[data-sizepv-phone]');
    phone.style.transform = 'translate(' + phoneLeft.toFixed(1) + 'px,' + phoneTop.toFixed(1) + 'px) scale(' + ref.toFixed(4) + ')';
    // captions sit centred under card and phone; for the big dolls the
    // references shrink until the two captions would touch, so push them
    // apart around their shared midpoint, keeping the phone's inside the frame
    var cardLbls = [wrap.querySelector('[data-sizepv-cardlbl1]'), wrap.querySelector('[data-sizepv-cardlbl2]')];
    var phoneLbls = [wrap.querySelector('[data-sizepv-phonelbl1]'), wrap.querySelector('[data-sizepv-phonelbl2]')];
    var widthOf = function (el) { var w = 0; try { w = el.getComputedTextLength(); } catch (e) { w = 0; } return w || el.textContent.length * 4.5; };
    var cw = Math.max(widthOf(cardLbls[0]), widthOf(cardLbls[1]));
    var pw = Math.max(widthOf(phoneLbls[0]), widthOf(phoneLbls[1]));
    var lcx = cardCx, lpx = phoneCx;
    var overlap = (lcx + cw / 2 + 8) - (lpx - pw / 2);
    if (overlap > 0) { lcx -= overlap / 2; lpx += overlap / 2; }
    var lpxMax = PV_W - 6 - pw / 2;
    if (lpx > lpxMax) { lcx -= lpx - lpxMax; lpx = lpxMax; }
    cardLbls.forEach(function (el) { el.setAttribute('x', lcx.toFixed(1)); });
    phoneLbls.forEach(function (el) { el.setAttribute('x', lpx.toFixed(1)); });

    var doll = wrap.querySelector('[data-sizepv-doll]');
    doll.style.transform = 'translate(' + PV_DOLL_X + 'px,' + PV_BASE + 'px) scale(' + s.toFixed(4) + ')';
    doll.style.opacity = selected ? '1' : '0';

    var dim = wrap.querySelector('[data-sizepv-dim]');
    var dimX = PV_DOLL_X - 26 * s - 12;     // just left of the doll's widest point
    dim.style.transform = 'translate(' + dimX.toFixed(1) + 'px,0)';
    dim.style.opacity = selected ? '1' : '0';
    // rect y/height: attributes for every browser, CSS properties where they
    // exist so the line glides instead of snapping
    var dimv = wrap.querySelector('[data-sizepv-dimv]');
    var dimTop = wrap.querySelector('[data-sizepv-dimtop]');
    dimv.setAttribute('y', (PV_BASE - h).toFixed(1)); dimv.setAttribute('height', h.toFixed(1));
    dimv.style.setProperty('y', (PV_BASE - h).toFixed(1) + 'px'); dimv.style.setProperty('height', h.toFixed(1) + 'px');
    dimTop.setAttribute('y', (PV_BASE - h - 0.7).toFixed(1));
    dimTop.style.setProperty('y', (PV_BASE - h - 0.7).toFixed(1) + 'px');
    var cmEl = wrap.querySelector('[data-sizepv-dimcm]');
    var inEl = wrap.querySelector('[data-sizepv-dimin]');
    cmEl.setAttribute('y', (PV_BASE - h / 2 - 2).toFixed(1));
    inEl.setAttribute('y', (PV_BASE - h / 2 + 10).toFixed(1));
    cmEl.textContent = selected ? selected.cm : '';
    inEl.textContent = selected ? (inches + ' in') : '';
    wrap.querySelector('[data-sizepv-title]').textContent = selected ? (inches + ' inches · ' + selected.cm) : '';

    wrap.querySelectorAll('.personalizer__axis-pill').forEach(function (p) {
      var on = !!selected && p.getAttribute('data-axis') === selected.val.name;
      p.classList.toggle('personalizer__axis-pill--sel', on);
      p.setAttribute('aria-checked', on ? 'true' : 'false');
    });
    return true;
  }

  /* One axis pill (shared by the plain row and the size preview). The
     merchant's "(Sold Out)" note is stripped — the chip says it properly —
     and any other parenthetical ("Best Gift") becomes the small tag line. */
  function buildAxisPill(ctx, val) {
    var sel = ctx.state.axis === val.name;
    var pill = document.createElement('button');
    pill.type = 'button';
    pill.className = 'personalizer__axis-pill' + (sel ? ' personalizer__axis-pill--sel' : '')
      + (val.soldOut ? ' personalizer__axis-pill--out' : '');
    pill.setAttribute('role', 'radio');
    pill.setAttribute('aria-checked', sel ? 'true' : 'false');
    pill.setAttribute('data-axis', val.name);
    var clean = val.name.replace(/\s*\(\s*sold\s*out\s*\)\s*/i, '').trim();
    var noteMatch = /^(.*?)\s*\(([^)]+)\)\s*$/.exec(clean);
    var labelEl = document.createElement('span');
    labelEl.className = 'personalizer__axis-label';
    labelEl.textContent = noteMatch ? noteMatch[1].trim() : clean;
    pill.appendChild(labelEl);
    if (noteMatch) {
      var tag = document.createElement('span');
      tag.className = 'personalizer__axis-tag';
      tag.textContent = noteMatch[2].trim();
      pill.appendChild(tag);
      pill.setAttribute('data-tagged', '1');
    }
    if (val.soldOut) {
      var out = document.createElement('small');
      out.textContent = 'Sold out';
      pill.appendChild(out);
      pill.disabled = true;
      pill.title = 'Currently unavailable';
    } else {
      pill.addEventListener('click', function () { if (ctx.state.axis !== val.name) ctx.setAxis(val.name); });
    }
    return pill;
  }

  /* Step 1 (count mode with a second product option, e.g. the mobile frame):
     pills for every axis value found in the variants. Values the merchant
     flagged sold out — or that have no orderable variant left — render as
     disabled chips rather than disappearing, so customers still see the
     option exists. */
  function renderAxis(ctx) {
    var mount = ctx.root.querySelector('[data-personalizer-axis]');
    if (!mount) return;
    var axisCfg = ctx.config.countAxis;
    if (!axisCfg || ctx.config.bagMode !== 'count') { mount.innerHTML = ''; mount.hidden = true; return; }
    var values = window.PersonalizerCart.axisValues(ctx.config);
    if (values.length < 2) { mount.innerHTML = ''; mount.hidden = true; return; }
    mount.hidden = false;
    if (axisCfg.preview === 'scale' && ctx.config.sizeGuide && renderSizePreview(ctx, mount, values, axisCfg)) return;
    mount.innerHTML = '';
    var q = document.createElement('div');
    q.className = 'personalizer__q';
    q.textContent = axisCfg.label || 'Choose an option';
    // Products whose axis IS a size (the memorial dolls) carry a sizeGuide in
    // config; its dialog is rendered by the embed and wired by delegation in
    // personalizer-render.js, so this button survives every axis re-render.
    if (ctx.config.sizeGuide) {
      var qrow = document.createElement('div');
      qrow.className = 'personalizer__qrow';
      qrow.appendChild(q);
      var sgBtn = document.createElement('button');
      sgBtn.type = 'button';
      sgBtn.className = 'personalizer__linkpill';
      sgBtn.setAttribute('data-sizeguide-open', '');
      sgBtn.textContent = ctx.config.sizeGuide.button || 'Size chart';
      qrow.appendChild(sgBtn);
      mount.appendChild(qrow);
    } else {
      mount.appendChild(q);
    }
    var row = document.createElement('div');
    row.className = 'personalizer__axis';
    row.setAttribute('role', 'radiogroup');
    row.setAttribute('aria-label', q.textContent);
    // The selling note ("Best Gift") is a second, smaller line INSIDE the
    // pill: a floating tag clipped against the pill edge and cost a band of
    // empty space above the row; inline after the label doubled the width.
    // When any pill carries one, the whole row shares the two-line height.
    values.forEach(function (val) {
      var pill = buildAxisPill(ctx, val);
      if (pill.getAttribute('data-tagged')) row.classList.add('personalizer__axis--tagged');
      row.appendChild(pill);
    });
    mount.appendChild(row);
  }

  /* Step 1: three count cards — 🧸 repeated per count, label under. oneBag
     cards also show the real combo price ("$169" + small "+$59"), so the jump
     between counts is explained BEFORE the customer picks. */
  function renderCounts(ctx) {
    var mount = ctx.root.querySelector('[data-personalizer-counts]');
    if (!mount) return;
    mount.innerHTML = '';

    // Per-count price from the actual variants — oneBag reads combo variants,
    // count mode (mobiles) reads the product's own "N Pets" variants.
    var oneBag = ctx.config.bagMode === 'oneBag';
    var countMode = ctx.config.bagMode === 'count';
    function oneBagPriceCents(n) {
      var v = countMode
        ? window.PersonalizerCart.countVariant(ctx.config, n, ctx.state.axis)
        : window.PersonalizerCart.oneBagComboVariant(ctx.config, ctx.state.orderType || 'full', n);
      return v ? v.price : 0;
    }

    var maxUnits = parseInt(ctx.config.maxUnits, 10) || 3;
    var counts = [];
    for (var ci = 1; ci <= maxUnits; ci++) counts.push(ci);
    counts.forEach(function (n) {
      // Bag products open with nothing picked: the state carries a working
      // count from the first paint, but no card is lit until it is the
      // customer's own choice (state.countChosen).
      var sel = ctx.state.besties.length === n
        && (!oneBag || ctx.state.countChosen);
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'personalizer__count' + (sel ? ' personalizer__count--sel' : '');
      b.setAttribute('role', 'radio');
      b.setAttribute('aria-checked', sel ? 'true' : 'false');
      var unitLc = unitOf(ctx).toLowerCase();
      var priceLine = '';
      var popChip = '';
      if (oneBag || countMode) {
        var cents = oneBagPriceCents(n);
        var prev = n > 1 ? oneBagPriceCents(n - 1) : 0;
        var compare = 0;
        if (countMode) {
          var cv = window.PersonalizerCart.countVariant(ctx.config, n, ctx.state.axis);
          if (cv && cv.compare > cv.price) compare = cv.compare;
          // "(Most Popular)" baked into the variant title becomes a tiny chip
          if (cv && /popular/i.test(String(cv.title || ''))) popChip = '<span class="personalizer__count-pop">POPULAR</span>';
        } else {
          // oneBag tiers can be discounted too (the charm page's 2- and
          // 3-pet prices) — the strike and −% chip read off the combo variant.
          var ov = window.PersonalizerCart.oneBagComboVariant(
            ctx.config, ctx.state.orderType || 'full', n, false);
          if (ov && ov.compare > ov.price) compare = ov.compare;
        }
        if (cents) {
          // A discounted tier shows what it saves (the struck full price);
          // undiscounted tiers show what one more costs. Never both — two
          // small numbers after the price read as noise.
          // The struck price says it costs less; a small −10% chip beside it
          // says how much, without another line of shouting text.
          var savePct = compare ? Math.round((1 - cents / compare) * 100) : 0;
          priceLine = '<div class="personalizer__count-pr">' + esc(money(ctx, cents))
            + (compare
              ? '<span class="personalizer__count-was"><s>' + esc(money(ctx, compare)) + '</s>'
                + '<em class="personalizer__count-save">&#8722;' + savePct + '%</em></span>'
              : (n > 1 && prev && cents - prev > 0 ? '<small>+' + esc(money(ctx, cents - prev)) + '</small>' : ''))
            + '</div>';
        }
        // Per-count chip from the config ("BEST SELLER" on the two-doll
        // card) — wins over the title-derived POPULAR when both exist.
        var cfgBadge = (ctx.config.countBadges || {})[String(n)];
        if (cfgBadge) popChip = '<span class="personalizer__count-pop">' + esc(cfgBadge) + '</span>';
      }
      // 4+ pets: repeating icons overflow the card — show one icon + xN.
      // countIconArt "charm" swaps the emoji for a drawn row of hanging
      // charms, so each card previews its own combination in miniature.
      var icons;
      // "charm" draws pet charms; "charm-people" draws a couple's mini-mes.
      if (/^charm/.test(ctx.config.countIconArt || '')
        && window.PersonalizerBagArt && window.PersonalizerBagArt.charmRow) {
        icons = window.PersonalizerBagArt.charmRow(Math.min(n, 3),
          ctx.config.countIconArt === 'charm-people' ? 'people' : 'pet');
      } else {
        icons = n <= 3
          ? (ctx.config.countIcon || '🧸').repeat(n)
          : (ctx.config.countIcon || '🧸') + '×' + n;
      }
      b.innerHTML = popChip
        + '<div class="personalizer__count-ic" aria-hidden="true">' + icons + '</div>'
        + '<div class="personalizer__count-tx">' + n + ' ' + esc(n === 1 ? unitLc : unitLc + 's') + '</div>'
        + priceLine;
      if (countMode && !window.PersonalizerCart.countVariant(ctx.config, n, ctx.state.axis)) {
        b.disabled = true;
        b.classList.add('personalizer__count--out');
      } else {
        b.addEventListener('click', function () { ctx.setCount(n); });
      }
      mount.appendChild(b);
    });
    renderBagPreview(ctx);
    renderSameSubject(ctx);
  }

  /* Step 1 preview panel: the chosen combination drawn large, in the same
     framed tile the colour step uses. The count cards are for comparing
     options; this is for believing the one you landed on — so it stays away
     until a count has actually been chosen.

     The same tile serves the memorial dolls (count mode with countAxis
     .ownStep): the drawing is N dolls each beside its own photo card, and the
     line under it does the gentle work of suggesting a second one. */
  function renderBagPreview(ctx) {
    var mount = ctx.root.querySelector('[data-personalizer-bag-preview]');
    if (!mount) return;
    if (ctx.config.bagMode === 'count') {
      renderDollPreview(ctx, mount);
      return;
    }
    if (ctx.config.bagMode !== 'oneBag' || !ctx.state.countChosen || !window.PersonalizerBagArt) {
      mount.innerHTML = '';
      mount.hidden = true;
      // Nothing drawn yet means nothing to explain either.
      updateSamePetGuide(ctx, null, 0);
      return;
    }
    var orderType = ctx.state.orderType || 'full';
    var n = ctx.state.besties.length || 1;
    // Pages that already show the combination on the count cards themselves
    // (config.noCountPreview) skip the big tile — the "only 1 pet?" guide
    // still runs, it never lived inside the drawing.
    if (ctx.config.noCountPreview) {
      mount.innerHTML = '';
      mount.hidden = true;
      updateSamePetGuide(ctx, orderType, n);
      return;
    }
    var def = window.PersonalizerCart.typeDef(ctx.config, orderType);
    var unitLc = unitOf(ctx).toLowerCase();
    var caption = (def ? shortLabel(def) + ' · ' : '') + n + ' ' + (n === 1 ? unitLc : unitLc + 's');
    mount.innerHTML = '<div class="personalizer__mk">'
      + window.PersonalizerBagArt.svg(orderType, n,
        unitLc === 'pet' ? 'pet' : 'doll', pickedHex(ctx))
      + '<span class="personalizer__mk-pillc personalizer__mk-pillc--plain">' + esc(caption) + '</span></div>';
    mount.hidden = false;
    updateSamePetGuide(ctx, orderType, n);
  }

  /* Memorial preview (count mode + countAxis.ownStep, config.sizeGuide): the
     SAME framed figure as the size step — white tile, 300×230 camera, floor
     line, the amigurumi doll beside its 6×4″ photo card — so stepping from
     "size" to "how many" keeps the frame still and only its contents change.
     One doll is drawn at exactly the size step's zoom; two or three doll+card
     pairs zoom out just enough to fit side by side. Answering "the same
     person" keeps every doll identical; "different people" tints shirt and
     hair per doll through the sprite's CSS variables. Under the frame sits the
     quiet nudge ("make it two") or the one-line affirmation. */
  var PV_PAIR_GAP = 16;
  var PV_PEOPLE = [
    {},
    { '--pz-doll-shirt': '#8aa58c', '--pz-doll-shirt2': '#73907a', '--pz-doll-pants': '#6f7f93', '--pz-doll-hair': '#d9c5a0', '--pz-doll-hair2': '#c6b088' },
    { '--pz-doll-shirt': '#c98a8a', '--pz-doll-shirt2': '#ad7272', '--pz-doll-pants': '#4f5b7a', '--pz-doll-hair': '#6b4a35', '--pz-doll-hair2': '#59392a' }
  ];
  var PV_TINT_KEYS = ['--pz-doll-shirt', '--pz-doll-shirt2', '--pz-doll-pants', '--pz-doll-hair', '--pz-doll-hair2'];
  function renderDollPreview(ctx, mount) {
    var cfg = ctx.config;
    var sg = cfg.sizeGuide;
    if (!(cfg.countAxis && cfg.countAxis.ownStep) || !sg) {
      mount.innerHTML = '';
      mount.hidden = true;
      return;
    }
    var n = Math.max(1, Math.min(3, ctx.state.besties.length || 1));
    var im = /(\d+(?:\.\d+)?)/.exec(String(ctx.state.axis || ''));
    var inches = im ? parseFloat(im[1]) : 8;
    var cardW = (sg.card && sg.card.w) || 6, cardH = (sg.card && sg.card.h) || 4;
    var unitLc = (cfg.unitLabel || 'Doll').toLowerCase();
    var cardLabel = (sg.card && sg.card.label) ? sg.card.label.toLowerCase() : 'photo card';

    var wrap = mount.querySelector('[data-dollpv]');
    if (!wrap) {
      mount.innerHTML = '';
      wrap = document.createElement('div');
      wrap.className = 'personalizer__sizepv personalizer__dollpv';
      wrap.setAttribute('data-dollpv', '');
      var fig = document.createElement('div');
      fig.className = 'personalizer__sizepv-fig';
      var svg = '<svg viewBox="0 0 ' + PV_W + ' ' + PV_H + '" aria-hidden="true" focusable="false">'
        + '<text class="personalizer__sizepv-title" data-dollpv-title x="14" y="22"></text>'
        + '<line class="personalizer__sizepv-floor" x1="16" x2="' + (PV_W - 16) + '" y1="' + PV_BASE + '" y2="' + PV_BASE + '"/>';
      for (var i = 0; i < 3; i++) {
        svg += '<g class="personalizer__dollpv-pair" data-dollpv-pair="' + i + '">'
          + '<g class="personalizer__sizepv-ref" data-dollpv-card><use href="#pz-sg-card" xlink:href="#pz-sg-card"></use></g>'
          + '<text class="personalizer__sizepv-reflbl" data-dollpv-lbl1 y="' + (PV_BASE + 13) + '" text-anchor="middle"></text>'
          + '<text class="personalizer__sizepv-reflbl" data-dollpv-lbl2 y="' + (PV_BASE + 24) + '" text-anchor="middle"></text>'
          + '<g class="personalizer__sizepv-doll" data-dollpv-doll><use href="#pz-sg-doll" xlink:href="#pz-sg-doll" transform="translate(-26,-100)"></use></g>'
          + '</g>';
      }
      fig.innerHTML = svg + '</svg>';
      wrap.appendChild(fig);
      var noteEl = document.createElement('p');
      noteEl.className = 'personalizer__mk-note personalizer__dollpv-note';
      noteEl.setAttribute('data-dollpv-note', '');
      wrap.appendChild(noteEl);
      mount.appendChild(wrap);
    }

    // camera: one doll = the size step's zoom; more pairs shrink to fit
    var k1 = pvZoom(inches, cardW);
    var k = n === 1 ? k1
      : Math.min(k1, (PV_W - 28 + 24 * n - (n - 1) * PV_PAIR_GAP) / (n * (0.52 * inches + cardW)));
    var h = inches * k, s = h / 100, ref = k / 10;
    var pairW = k * (0.52 * inches + cardW) - 24;   // doll's left edge → card's right edge
    var total = n * pairW + (n - 1) * PV_PAIR_GAP;
    var firstCx = (PV_W - total) / 2 + 26 * s;
    var tintAll = ctx.state.sameSubject === false && n > 1;
    for (var p = 0; p < 3; p++) {
      var g = wrap.querySelector('[data-dollpv-pair="' + p + '"]');
      g.style.opacity = p < n ? '1' : '0';
      // pairs beyond the count park on the last visible one, so a new pair
      // slides out from its neighbour instead of popping in from nowhere
      var cx = firstCx + Math.min(p, n - 1) * (pairW + PV_PAIR_GAP);
      var cardLeft = cx + 0.26 * h - 24, cardTop = PV_BASE - cardH * k;
      g.querySelector('[data-dollpv-card]').style.transform =
        'translate(' + cardLeft.toFixed(1) + 'px,' + cardTop.toFixed(1) + 'px) scale(' + ref.toFixed(4) + ')';
      var cardCx = (cardLeft + cardW * k / 2).toFixed(1);
      var l1 = g.querySelector('[data-dollpv-lbl1]'), l2 = g.querySelector('[data-dollpv-lbl2]');
      l1.setAttribute('x', cardCx); l2.setAttribute('x', cardCx);
      l1.textContent = cardLabel;
      l2.textContent = n === 1 ? (cardW + ' × ' + cardH + ' in · included') : 'included';
      var doll = g.querySelector('[data-dollpv-doll]');
      doll.style.transform = 'translate(' + cx.toFixed(1) + 'px,' + PV_BASE + 'px) scale(' + s.toFixed(4) + ')';
      var tint = tintAll ? (PV_PEOPLE[p] || {}) : {};
      PV_TINT_KEYS.forEach(function (key) {
        if (tint[key]) doll.style.setProperty(key, tint[key]); else doll.style.removeProperty(key);
      });
    }
    wrap.querySelector('[data-dollpv-title]').textContent =
      n + ' ' + (n === 1 ? unitLc : unitLc + 's') + ' · ' + inches + ' inches' + (n > 1 ? ' each' : '');

    var cp = cfg.countPreview || {};
    var note = wrap.querySelector('[data-dollpv-note]');
    if (n === 1) {
      note.innerHTML = esc(cp.nudge || 'Many families order two — one to keep, one to gift.')
        + ' <button type="button" class="personalizer__linkpill personalizer__mk-note-cta" data-doll-two>'
        + esc(cp.nudgeCta || 'Make it two') + '</button>';
      note.querySelector('[data-doll-two]').addEventListener('click', function () { ctx.setCount(2); });
    } else {
      note.textContent = cp.affirm || 'Each doll arrives with its own card.';
    }
    mount.hidden = false;
  }

  /* "Are the dolls of the same person?" — under the count cards from two
     dolls up (config.sameSubject). Nothing is assumed: the answer gates Next
     (personalizer.js stepValid), reaches the order line ("Same person"),
     merges the card name/dates fields into one when they are the same
     (renderNames) and tints the preview dolls apart when they are not. */
  function renderSameSubject(ctx) {
    var mount = ctx.root.querySelector('[data-personalizer-same]');
    if (!mount) return;
    var ss = ctx.config.sameSubject;
    var n = ctx.state.besties.length;
    if (!ss || n < 2) { mount.innerHTML = ''; mount.hidden = true; return; }
    var unitLc = unitOf(ctx).toLowerCase();
    // {units} before {unit}: the plural token contains the singular one
    var fill = function (t) {
      return String(t || '').split('{n}').join(n).split('{units}').join(unitLc + 's').split('{unit}').join(unitLc);
    };
    mount.innerHTML = '';
    var q = document.createElement('div');
    q.className = 'personalizer__q personalizer__q--same';
    q.textContent = fill(ss.label || 'Are the {n} {units} of the same person?');
    mount.appendChild(q);
    var row = document.createElement('div');
    row.className = 'personalizer__axis personalizer__axis--same';
    row.setAttribute('role', 'radiogroup');
    row.setAttribute('aria-label', q.textContent);
    [
      { v: true, label: ss.same || 'The same person', sub: ss.sameSub || '{n} matching {units} of one person' },
      { v: false, label: ss.different || 'Different people', sub: ss.differentSub || 'one {unit} for each person' }
    ].forEach(function (opt) {
      var sel = ctx.state.sameSubject === opt.v;
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'personalizer__axis-pill' + (sel ? ' personalizer__axis-pill--sel' : '');
      b.setAttribute('role', 'radio');
      b.setAttribute('aria-checked', sel ? 'true' : 'false');
      b.setAttribute('data-same', opt.v ? 'yes' : 'no');
      b.innerHTML = '<span class="personalizer__axis-label">' + esc(opt.label) + '</span>'
        + '<span class="personalizer__axis-price">' + esc(fill(opt.sub)) + '</span>';
      b.addEventListener('click', function () { ctx.setSameSubject(opt.v); });
      row.appendChild(b);
    });
    mount.appendChild(row);
    mount.hidden = false;
  }

  /* wireDialog moves dialogs to <body> the first time one opens, so a
     root-scoped lookup stops finding them after that. */
  function findDialogPart(ctx, sel) {
    return ctx.root.querySelector(sel) || document.querySelector(sel);
  }

  /* Toggle by attribute, not by the .hidden property: an <svg> is an
     SVGElement, which does not reflect .hidden onto the attribute, so the
     property silently sets nothing the CSS can see. */
  function setShown(el, show) {
    if (!el) return;
    if (show) el.removeAttribute('hidden');
    else el.setAttribute('hidden', '');
  }

  /* "Only 1 pet?" for bag products — the same nudge the nursery mobiles use,
     with the bag's own scene inside. Reassurance for the one-pet household
     picking more than one charm: the count is not a headcount, it is how many
     crochet dolls get made. The button appears only where extra dolls exist —
     a tote's embroidery is not duplicated, and one charm is not repeated. */
  function updateSamePetGuide(ctx, orderType, n) {
    if (ctx.config.bagMode !== 'oneBag') return;
    var btn = ctx.root.querySelector('[data-onepet-open]');
    if (!btn) return;
    // From 1 up: at n=1 the dialog's job flips from reassurance ("the count
    // is not a headcount") to invitation ("one pet can wear every bag").
    var offer = n >= 1 && (orderType === 'full' || orderType === 'charm');
    btn.hidden = !offer;
    if (!offer) return;

    var unitLc = unitOf(ctx).toLowerCase();
    var fill = function (tpl) {
      return String(tpl).split('{n}').join(n).split('{unit}').join(unitLc);
    };
    var title = findDialogPart(ctx, '[data-onepet-title]');
    if (title) title.textContent = fill(ctx.config.samePetTitle || 'Only one {unit}? Perfect.');
    var text = findDialogPart(ctx, '[data-onepet-text]');
    if (text) {
      var tpl = n === 1
        ? (ctx.config.samePetNoteOne
          || 'One {unit}, one charm — and if you ever want their mini-me on more than one bag, pick 2 or 3 and we’ll crochet the same buddy for each.')
        : (ctx.config.samePetNote
          || "We'll crochet the same one {n} times — hang them together on your bag, or clip one to another bag you love.");
      text.textContent = fill(tpl);
    }
    // The packaged drawing is a nursery mobile; a tote order gets its own.
    setShown(findDialogPart(ctx, '[data-onepet-art-mobile]'), false);
    var bagArt = findDialogPart(ctx, '[data-onepet-art-bag]');
    if (bagArt && window.PersonalizerBagArt) {
      bagArt.innerHTML = window.PersonalizerBagArt.svg(orderType, n,
        unitLc === 'pet' ? 'pet' : 'doll', pickedHex(ctx));
      setShown(bagArt, true);
    }
  }

  /* Step 1: per-bestie rows of three type cards (drawing, name, green price,
     struck compareAt + green ribbon on discounted types, corner ✓ via CSS). */
  function renderTypeRows(ctx) {
    var mount = ctx.root.querySelector('[data-personalizer-type-rows]');
    if (!mount) return;
    mount.innerHTML = '';
    // Single-type products (e.g. full-set only): nothing to choose — every
    // unit already defaults to that type, so the rows would be dead weight.
    if ((ctx.config.types || []).length === 1) return;
    // oneBag mode: ONE tote carries every unit (pet 1 = full set, the rest are
    // extra doll charms on the same bag) — types are assigned automatically in
    // personalizer.js, never chosen per unit.
    if (ctx.config.bagMode === 'oneBag') return;
    ctx.state.besties.forEach(function (bestie, i) {
      var row = document.createElement('div');
      row.className = 'personalizer__brow';
      row.innerHTML = '<div class="personalizer__bl">' + esc(unitOf(ctx)) + ' ' + (i + 1) + '</div>';
      var grid = document.createElement('div');
      grid.className = 'personalizer__types';
      grid.setAttribute('role', 'radiogroup');
      grid.setAttribute('aria-label', 'Set for ' + unitOf(ctx).toLowerCase() + ' ' + (i + 1));
      ctx.config.types.forEach(function (def) {
        var sel = bestie.type === def.key;
        var card = document.createElement('button');
        card.type = 'button';
        card.className = 'personalizer__tcard' + (sel ? ' personalizer__tcard--sel' : '');
        card.setAttribute('role', 'radio');
        card.setAttribute('aria-checked', sel ? 'true' : 'false');
        card.setAttribute('aria-label', (def.label || def.key) + ' for ' + unitOf(ctx).toLowerCase() + ' ' + (i + 1));
        var compareCents = Math.round(parseFloat(def.compareAt) * 100) || 0;
        card.innerHTML = (def.badge ? '<span class="personalizer__ribbon">' + esc(def.badge) + '</span>' : '')
          + typeSvg(ctx, def)
          + '<div class="personalizer__tcard-nm">' + esc(shortLabel(def)) + '</div>'
          + '<div class="personalizer__tcard-pr">' + esc(money(ctx, window.PersonalizerCart.typePriceCents(ctx.config, def.key)))
          + (compareCents ? '<span class="personalizer__tcard-was">' + esc(money(ctx, compareCents)) + '</span>' : '')
          + '</div>';
        card.addEventListener('click', function () {
          bestie.type = def.key;
          if (!def.needsColor) bestie.color = null; // charm has no colour choice
          // In-place selected state (no row rebuild — keeps keyboard focus).
          grid.querySelectorAll('.personalizer__tcard').forEach(function (c) {
            c.classList.remove('personalizer__tcard--sel');
            c.setAttribute('aria-checked', 'false');
          });
          card.classList.add('personalizer__tcard--sel');
          card.setAttribute('aria-checked', 'true');
          renderColorRows(ctx); // colours step content follows the type mix
          ctx.onStateChange();
        });
        grid.appendChild(card);
      });
      row.appendChild(grid);
      mount.appendChild(row);
    });
  }

  /* Step 2: swatch row per colour-needing bestie (charm-only → mint note pill)
     + the one-row mockup strip. */
  function renderColorRows(ctx) {
    var mount = ctx.root.querySelector('[data-personalizer-color-rows]');
    if (!mount) return;
    mount.innerHTML = '';
    // oneBag mode: exactly one swatch row — the single tote's colour, stored
    // on unit 0 (the "full" one). No per-unit rows, no charm notes.
    if (ctx.config.bagMode === 'oneBag') {
      renderOneBagColorRow(ctx, mount);
      renderMockups(ctx);
      return;
    }
    ctx.state.besties.forEach(function (bestie, i) {
      var def = window.PersonalizerCart.typeDef(ctx.config, bestie.type);
      if (!def) return; // no type yet — step 2 unreachable until step 1 validates
      var row = document.createElement('div');
      row.className = 'personalizer__swrow';
      if (!def.needsColor) {
        row.innerHTML = '<div class="personalizer__bl">' + esc(unitOf(ctx)) + ' ' + (i + 1) + '</div>'
          + '<span class="personalizer__charm-note">' + esc(ctx.config.countIcon || '🧸') + ' charm only — no colour needed</span>';
        mount.appendChild(row);
        return;
      }
      var label = document.createElement('div');
      label.className = 'personalizer__bl';
      label.innerHTML = esc(unitOf(ctx)) + ' ' + (i + 1)
        + '<span class="personalizer__bl-echo" aria-live="polite">' + esc(bestie.color || 'tap a colour') + '</span>';
      row.appendChild(label);
      var sw = document.createElement('div');
      sw.className = 'personalizer__sw';
      sw.setAttribute('role', 'radiogroup');
      sw.setAttribute('aria-label', 'Colour for ' + unitOf(ctx).toLowerCase() + ' ' + (i + 1));
      (ctx.config.palettes || []).forEach(function (palette) {
        var sel = bestie.color === palette.name;
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'personalizer__dot' + (sel ? ' personalizer__dot--sel' : '');
        dot.style.background = palette.hex;
        // White swatch needs a visible border on the white card.
        if (String(palette.hex).toLowerCase() === '#ffffff') dot.style.borderColor = '#c9c9c9';
        dot.setAttribute('role', 'radio');
        dot.setAttribute('aria-checked', sel ? 'true' : 'false');
        dot.setAttribute('aria-label', palette.name + ' for ' + unitOf(ctx).toLowerCase() + ' ' + (i + 1));
        dot.title = palette.name;
        dot.addEventListener('click', function () {
          bestie.color = palette.name;
          sw.querySelectorAll('.personalizer__dot').forEach(function (d) {
            d.classList.remove('personalizer__dot--sel');
            d.setAttribute('aria-checked', 'false');
          });
          dot.classList.add('personalizer__dot--sel');
          dot.setAttribute('aria-checked', 'true');
          label.querySelector('.personalizer__bl-echo').textContent = palette.name;
          renderMockups(ctx);
          ctx.onStateChange();
        });
        sw.appendChild(dot);
      });
      row.appendChild(sw);
      mount.appendChild(row);
    });
    renderMockups(ctx);
  }

  /* oneBag: the single "Bag colour" swatch row, bound to unit 0. */
  function renderOneBagColorRow(ctx, mount) {
    var bag = ctx.state.besties[0];
    if (!bag) return;
    var row = document.createElement('div');
    row.className = 'personalizer__swrow';
    var label = document.createElement('div');
    label.className = 'personalizer__bl';
    label.innerHTML = 'Bag colour'
      + '<span class="personalizer__bl-echo" aria-live="polite">' + esc(bag.color || 'tap a colour') + '</span>';
    row.appendChild(label);
    var sw = document.createElement('div');
    sw.className = 'personalizer__sw';
    sw.setAttribute('role', 'radiogroup');
    sw.setAttribute('aria-label', 'Bag colour');
    (ctx.config.palettes || []).forEach(function (palette) {
      var sel = bag.color === palette.name;
      var dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'personalizer__dot' + (sel ? ' personalizer__dot--sel' : '');
      dot.style.background = palette.hex;
      if (String(palette.hex).toLowerCase() === '#ffffff') dot.style.borderColor = '#c9c9c9';
      dot.setAttribute('role', 'radio');
      dot.setAttribute('aria-checked', sel ? 'true' : 'false');
      dot.setAttribute('aria-label', palette.name + ' bag');
      dot.title = palette.name;
      dot.addEventListener('click', function () {
        bag.color = palette.name;
        sw.querySelectorAll('.personalizer__dot').forEach(function (d) {
          d.classList.remove('personalizer__dot--sel');
          d.setAttribute('aria-checked', 'false');
        });
        dot.classList.add('personalizer__dot--sel');
        dot.setAttribute('aria-checked', 'true');
        label.querySelector('.personalizer__bl-echo').textContent = palette.name;
        renderMockups(ctx);
        // Step 1's drawing wears the bag colour too, so stepping back shows
        // the bag they just chose rather than the one they started with.
        renderBagPreview(ctx);
        ctx.onStateChange();
      });
      sw.appendChild(dot);
    });
    row.appendChild(sw);
    mount.appendChild(row);
  }

  /* Mockup strip: ALL coloured besties at once in ONE row. Per bestie: the
     palette's mockup image when configured, else the cartoon tote SVG; below
     it a colour-filled caption pill ("Bestie N · Colour"). oneBag mode shows
     the single tote with a colour-name pill. */
  function renderMockups(ctx) {
    var mount = ctx.root.querySelector('[data-personalizer-mockups]');
    if (!mount) return;
    if (ctx.config.bagMode === 'oneBag') {
      var bag = ctx.state.besties[0];
      var pal = null;
      (ctx.config.palettes || []).forEach(function (p) { if (bag && p.name === bag.color) pal = p; });
      if (!pal) { mount.innerHTML = ''; mount.hidden = true; return; }
      var m = pal.mockup
        ? '<img src="' + esc(pal.mockup) + '" alt="' + esc('Tote mockup in ' + pal.name) + '" loading="lazy">'
        : toteSvg(pal.hex);
      var ps = 'background:' + esc(pal.hex) + ';color:' + pillTextColor(pal.hex)
        + (String(pal.hex).toLowerCase() === '#ffffff' ? ';border:1px solid #d8d8d8' : '');
      mount.innerHTML = '<div class="personalizer__mk">' + m
        + '<span class="personalizer__mk-pillc" style="' + ps + '">' + esc(pal.name) + '</span></div>';
      mount.hidden = false;
      return;
    }
    var html = '';
    ctx.state.besties.forEach(function (bestie, i) {
      var def = window.PersonalizerCart.typeDef(ctx.config, bestie.type);
      if (!def || !def.needsColor || !bestie.color) return;
      var palette = null;
      (ctx.config.palettes || []).forEach(function (p) { if (p.name === bestie.color) palette = p; });
      if (!palette) return;
      var media = palette.mockup
        ? '<img src="' + esc(palette.mockup) + '" alt="' + esc('Tote mockup in ' + palette.name) + '" loading="lazy">'
        : toteSvg(palette.hex);
      var pillStyle = 'background:' + esc(palette.hex) + ';color:' + pillTextColor(palette.hex)
        + (String(palette.hex).toLowerCase() === '#ffffff' ? ';border:1px solid #d8d8d8' : '');
      html += '<div class="personalizer__mk">' + media
        + '<span class="personalizer__mk-pillc" style="' + pillStyle + '">' + esc(unitOf(ctx)) + ' ' + (i + 1) + ' · ' + esc(palette.name) + '</span></div>';
    });
    mount.innerHTML = html;
    mount.hidden = !html;
  }

  /* Step 3: one embroidery-name input per unit (products with
     config.nameField only — hidden otherwise). Values live in
     state.besties[i].petName; typing saves + refreshes nav enablement via
     ctx.onFieldInput (NO rebuild — focus must survive every keystroke). */
  function renderNames(ctx) {
    var mount = ctx.root.querySelector('[data-personalizer-names]');
    if (!mount) return;
    var nf = ctx.config.nameField;
    // Dolls-only orders (oneBag charm) have no bag — nothing to embroider.
    var noBag = ctx.config.bagMode === 'oneBag' && (ctx.state.orderType || 'full') === 'charm';
    if (!nf || noBag) { mount.innerHTML = ''; mount.hidden = true; return; }
    mount.hidden = false;
    mount.innerHTML = '';
    var title = document.createElement('div');
    title.className = 'personalizer__q personalizer__q--names';
    title.textContent = nf.label || 'Name for the embroidery';
    mount.appendChild(title);
    if (ctx.config.extraField && ctx.config.extraField.hint) {
      var xhint = document.createElement('p');
      xhint.className = 'personalizer__subhint';
      xhint.style.margin = '0 0 6px';
      xhint.textContent = ctx.config.extraField.hint;
      mount.appendChild(xhint);
    }

    // One line for the whole piece: the customer writes it exactly as they
    // want it stitched, including how they join two names.
    if (nf.single) {
      var srow = document.createElement('div');
      srow.className = 'personalizer__namerow personalizer__namerow--single';
      var sinput = document.createElement('input');
      sinput.type = 'text';
      sinput.id = 'personalizer-name-single';
      sinput.className = 'personalizer__name-input';
      sinput.maxLength = nf.max || 40;
      sinput.placeholder = nf.placeholder || 'e.g. Luna';
      sinput.autocomplete = 'off';
      sinput.setAttribute('aria-label', nf.label || 'Name to embroider');
      sinput.value = ctx.state.orderName || '';
      sinput.addEventListener('input', function () {
        ctx.state.orderName = sinput.value;
        if (ctx.onFieldInput) ctx.onFieldInput();
      });
      srow.appendChild(sinput);
      mount.appendChild(srow);
      if (nf.hint) {
        var shint = document.createElement('p');
        shint.className = 'personalizer__subhint';
        shint.style.margin = '6px 0 0';
        shint.textContent = nf.hint;
        mount.appendChild(shint);
      }
      return;
    }

    // "Same person" orders print the same card for every doll: one row,
    // whose values are mirrored onto every unit as they are typed.
    var sameOne = !!(ctx.config.sameSubject && ctx.state.sameSubject === true && ctx.state.besties.length > 1);
    var units = ctx.state.besties;
    if (sameOne) {
      units.forEach(function (b, j) { if (j) { b.petName = units[0].petName; b.petExtra = units[0].petExtra; } });
    }
    var rows = sameOne ? [units[0]] : units;
    rows.forEach(function (bestie, i) {
      var targets = sameOne ? units : [bestie];
      var row = document.createElement('div');
      row.className = 'personalizer__namerow';
      var id = 'personalizer-name-' + (i + 1);
      var lab = document.createElement('label');
      lab.className = 'personalizer__bl';
      lab.setAttribute('for', id);
      lab.textContent = sameOne
        ? String(ctx.config.sameSubject.cardsLabel || 'All {n} cards').split('{n}').join(units.length)
        : unitOf(ctx) + ' ' + (i + 1);
      var input = document.createElement('input');
      input.type = 'text';
      input.id = id;
      input.className = 'personalizer__name-input';
      input.maxLength = 40;
      input.placeholder = nf.placeholder || 'e.g. Luna';
      input.autocomplete = 'off';
      input.value = bestie.petName || '';
      input.addEventListener('input', function () {
        targets.forEach(function (b) { b.petName = input.value; });
        if (ctx.onFieldInput) ctx.onFieldInput();
        renderCardPreview(ctx, i); // live on the card
      });
      input.addEventListener('focus', function () { renderCardPreview(ctx, i); });
      row.appendChild(lab);
      row.appendChild(input);

      // Optional second per-unit field (config.extraField) — e.g. the EST.
      // year stitched under a varsity arch. Narrow input beside the name.
      var xf = ctx.config.extraField;
      if (xf) {
        var xin = document.createElement('input');
        xin.type = 'text';
        xin.id = id + '-x';
        xin.className = 'personalizer__name-input personalizer__name-input--sm';
        // 12 fits the varsity EST. year; the memorial dates need more room
        xin.maxLength = xf.max || 12;
        xin.placeholder = xf.placeholder || '';
        xin.autocomplete = 'off';
        xin.setAttribute('aria-label', (xf.label || 'Extra') + ' for ' + unitOf(ctx).toLowerCase() + ' ' + (i + 1));
        xin.value = bestie.petExtra || '';
        xin.addEventListener('input', function () {
          targets.forEach(function (b) { b.petExtra = xin.value; });
          if (ctx.onFieldInput) ctx.onFieldInput();
          renderCardPreview(ctx, i);
        });
        xin.addEventListener('focus', function () { renderCardPreview(ctx, i); });
        row.appendChild(xin);
      }
      mount.appendChild(row);
    });
  }

  /* Card step live preview (config.cardPreview): the real printed card in the
     same framed tile as the size and count steps — the artwork with the
     customer's photo dropped into its frame and the typed name/dates under
     it, updating keystroke by keystroke. Positions are the artwork's own
     pixel geometry (cardPreview.slot / name / dates, in template pixels).
     With different people, chips pick which doll's card is shown, and
     focusing a doll's field switches to its card. */
  function renderCardPreview(ctx, unitIdx) {
    var mount = ctx.root.querySelector('[data-personalizer-card-preview]');
    if (!mount) return;
    var cp = ctx.config.cardPreview;
    if (!cp || !cp.image || !cp.slot || !cp.name) { mount.innerHTML = ''; mount.hidden = true; return; }
    var n = ctx.state.besties.length;
    var split = !!(ctx.photoSplit && ctx.photoSplit());
    if (typeof unitIdx === 'number') ctx.state.cardPreviewUnit = unitIdx;
    var u = split ? Math.max(0, Math.min(ctx.state.cardPreviewUnit || 0, n - 1)) : 0;
    var W = cp.w || 1748, H = cp.h || 1240;
    var pct = function (box) {
      return 'left:' + (box.x / W * 100).toFixed(2) + '%;top:' + (box.y / H * 100).toFixed(2) + '%;width:'
        + (box.w / W * 100).toFixed(2) + '%;height:' + (box.h / H * 100).toFixed(2) + '%';
    };
    var wrap = mount.querySelector('[data-cardpv]');
    if (!wrap) {
      mount.innerHTML = '';
      wrap = document.createElement('div');
      wrap.className = 'personalizer__sizepv personalizer__cardpv';
      wrap.setAttribute('data-cardpv', '');
      wrap.innerHTML =
        '<div class="personalizer__sizepv-fig personalizer__cardpv-fig">' +
          '<div class="personalizer__cardpv-stage">' +
            '<div class="personalizer__cardpv-card" style="aspect-ratio:' + W + '/' + H + '">' +
              '<img class="personalizer__cardpv-bg" src="' + esc(cp.image) + '" alt="" decoding="async">' +
              '<div class="personalizer__cardpv-slot" style="' + pct(cp.slot) + '">' +
                '<img class="personalizer__cardpv-photo" data-cardpv-photo alt="" hidden>' +
                '<span class="personalizer__cardpv-ph" data-cardpv-ph>' + esc(cp.placeholder || 'their photo') + '</span>' +
              '</div>' +
              '<div class="personalizer__cardpv-name" data-cardpv-name style="' + pct(cp.name) + '"></div>' +
              (cp.dates ? '<div class="personalizer__cardpv-dates" data-cardpv-dates style="' + pct(cp.dates) + '"></div>' : '') +
            '</div>' +
          '</div>' +
        '</div>' +
        '<div class="personalizer__cardpv-chips" data-cardpv-chips hidden></div>';
      mount.appendChild(wrap);
    }
    // which doll's card (different people only)
    var chips = wrap.querySelector('[data-cardpv-chips]');
    chips.innerHTML = '';
    if (split && n > 1) {
      for (var i = 0; i < n; i++) {
        (function (idx) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'personalizer__linkpill personalizer__cardpv-chip' + (idx === u ? ' personalizer__cardpv-chip--sel' : '');
          b.textContent = unitOf(ctx) + ' ' + (idx + 1);
          b.setAttribute('aria-pressed', idx === u ? 'true' : 'false');
          b.addEventListener('click', function () { renderCardPreview(ctx, idx); });
          chips.appendChild(b);
        })(i);
      }
      chips.hidden = false;
    } else {
      chips.hidden = true;
    }
    // the photo: this doll's first photo (split) or the order's first photo
    var pg = ctx.photoGroup ? ctx.photoGroup() : null;
    var photos = [];
    if (pg) {
      var by = pg.getPhotosByUnit ? pg.getPhotosByUnit() : null;
      photos = by ? (by[u] || []) : pg.getPhotos();
    }
    var img = wrap.querySelector('[data-cardpv-photo]');
    var ph = wrap.querySelector('[data-cardpv-ph]');
    if (photos.length) {
      if (img.getAttribute('src') !== photos[0].url) img.src = photos[0].url;
      img.hidden = false;
      ph.hidden = true;
    } else {
      img.removeAttribute('src');
      img.hidden = true;
      ph.hidden = false;
    }
    var unit = ctx.state.besties[u] || {};
    var nameEl = wrap.querySelector('[data-cardpv-name]');
    var nm = String(unit.petName || '').trim();
    nameEl.textContent = nm || (cp.namePlaceholder || 'their name');
    nameEl.classList.toggle('personalizer__cardpv-txt--empty', !nm);
    var datesEl = wrap.querySelector('[data-cardpv-dates]');
    if (datesEl) {
      var dt = String(unit.petExtra || '').trim();
      datesEl.textContent = dt || (cp.datesPlaceholder || '');
      datesEl.classList.toggle('personalizer__cardpv-txt--empty', !dt);
    }
    mount.hidden = false;
  }

  /* Photos step rows: one upload group for the order or — while the dolls are
     different people — one labelled row per doll. personalizer.js owns the
     groups (built once, in doll order); this only shows, hides and labels
     them, and sets the one-line note under the hint. */
  function renderPhotoUnits(ctx) {
    var rootEl = ctx.root.querySelector('[data-photo-group]');
    if (!rootEl) return;
    var ss = ctx.config.sameSubject;
    var n = ctx.state.besties.length;
    var split = !!(ctx.photoSplit && ctx.photoSplit());
    var unit = unitOf(ctx);
    var mainLb = rootEl.querySelector('[data-photo-unit-label]');
    if (mainLb) { mainLb.textContent = unit + ' 1'; mainLb.hidden = !split; }
    rootEl.querySelectorAll('[data-photo-unit]').forEach(function (el) {
      var i = parseInt(el.getAttribute('data-photo-unit'), 10);
      el.hidden = !(split && i < n);
      var lb = el.querySelector('[data-photo-unit-label]');
      if (lb) lb.textContent = unit + ' ' + (i + 1);
    });
    var note = rootEl.querySelector('[data-photo-same-note]');
    if (note) {
      var txt = '';
      if (ss && n >= 2 && ctx.state.sameSubject === true) {
        txt = ss.photosSameNote || 'One set of photos is all we need — every ' + unit.toLowerCase() + ' is crocheted from the same person.';
      } else if (split) {
        txt = ss.photosSplitNote || 'Add each person’s photos under their own ' + unit.toLowerCase() + '.';
      }
      note.textContent = txt;
      note.hidden = !txt;
    }
  }

  /* Post-extras interstitial (config.twinOffer, oneBag): "make it a twin set"
     card shown as its own panel AFTER the extras step's Add-to-cart click.
     The sticky-bar submit on this panel does the real submit, twin or not. */
  function renderTwin(ctx) {
    var mount = ctx.root.querySelector('[data-personalizer-twin]');
    if (!mount) return;
    var offer = ctx.config.twinOffer;
    if (!offer || ctx.config.bagMode !== 'oneBag') { mount.innerHTML = ''; mount.hidden = true; return; }
    var single = window.PersonalizerCart.oneBagComboVariant(ctx.config, ctx.state.orderType || 'full', ctx.state.besties.length, false);
    if (!single) { mount.innerHTML = ''; mount.hidden = true; return; }
    var delta = Math.round(single.price * 0.8); // the 2nd set at 20% off
    // Twin illustration: the customer's own tote, twice — in the bag colour
    // they picked (falls back to mint before a colour is chosen).
    var bagHex = '#c1eac4';
    var bagColor = ctx.state.besties[0] && ctx.state.besties[0].color;
    (ctx.config.palettes || []).forEach(function (p) { if (p.name === bagColor) bagHex = p.hex; });
    mount.hidden = false;
    mount.innerHTML = ''
      + '<div class="personalizer__q">' + esc(offer.heading || 'One more thing 🎁') + '</div>'
      + '<p class="personalizer__subhint">' + esc(offer.description || '') + '</p>'
      + '<label class="personalizer__up personalizer__up--twin' + (ctx.state.twin ? ' personalizer__up--selected' : '') + '">'
      + '<input type="checkbox" class="personalizer__twin-input visually-hidden"' + (ctx.state.twin ? ' checked' : '') + '>'
      + '<span class="personalizer__up-media personalizer__up-media--twin" aria-hidden="true">' + toteSvg(bagHex) + toteSvg(bagHex) + '</span>'
      + '<span class="personalizer__up-body">'
      + '<span class="personalizer__up-name">' + esc(offer.title || 'Make it a twin set') + ' <span class="personalizer__up-reco">20% OFF</span></span>'
      + '<span class="personalizer__up-desc">' + esc(offer.rowText || 'Same photos, names & colours — twice.') + '</span>'
      + '</span>'
      + '<span class="personalizer__up-price theme-money">+' + esc(money(ctx, delta))
      + ' <s>' + esc(money(ctx, single.price)) + '</s></span>'
      + '<span class="personalizer__up-tick" aria-hidden="true">✓</span>'
      + '</label>';
    // NO per-render listener: the mount rebuilds on every refreshUI, so the
    // toggle is handled by ONE delegated listener bound once (personalizer.js)
    // — immune to rebuild races that could swallow the change event.
  }

  /* --- Extras expansions: shared unfold/collapse (the page grows instead of
     jumping) --- */
  function unfold(el) {
    el.classList.add('pz-unfold');
    requestAnimationFrame(function () { requestAnimationFrame(function () { el.classList.add('is-open'); }); });
  }
  function collapse(el) {
    if (!el || el.classList.contains('is-closing')) return;
    el.classList.add('is-closing');
    el.classList.remove('is-open');
    var gone = false;
    var drop = function () { if (!gone) { gone = true; el.remove(); } };
    el.addEventListener('transitionend', drop, { once: true });
    setTimeout(drop, 400);
  }
  /* Doll add-ons (wings note, name charm, photo charm) have nothing to pair
     with on a tote-only order: hide the row, untick it (dispatching change so
     state/pricing follow) and fold the holder away. Returns true when hidden. */
  function hideDollAddonRow(ctx, input, row, holder) {
    var noDolls = ctx.config.bagMode === 'oneBag' && (ctx.state.orderType || 'full') === 'tote';
    if (!noDolls) { row.hidden = false; return false; }
    row.hidden = true;
    if (input.checked) {
      input.checked = false;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
    if (holder) collapse(holder);
    return true;
  }

  /* the holder right after a row, if it is one of ours and not on its way out */
  function holderAfter(row, cls) {
    var h = row.nextElementSibling;
    if (!h || !h.classList || !h.classList.contains(cls)) return null;
    if (h.classList.contains('is-closing')) { h.remove(); return null; }
    return h;
  }

  /* Per-pet upsell expansion (config.perPetUpsells, e.g. wings & halo):
     with ONE pet the tick is the whole answer (pet 0 is chosen silently, no
     chip row); from two pets up a chip row picks WHICH pets get it — one or
     many — price = each × picked. Hidden (and force-unchecked) on tote-only
     orders: there are no dolls. */
  function renderUpsellPets(ctx) {
    var oneBag = ctx.config.bagMode === 'oneBag';
    ctx.root.querySelectorAll('.personalizer__upsell-input[data-per-pet]').forEach(function (input) {
      var row = input.closest('.personalizer__up');
      if (!row) return;
      var chips = holderAfter(row, 'personalizer__up-pets');
      var noDolls = oneBag && (ctx.state.orderType || 'full') === 'tote';
      if (noDolls) {
        row.hidden = true;
        if (input.checked) {
          input.checked = false;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
        if (chips) collapse(chips);
        return;
      }
      row.hidden = false;
      var priceEl = row.querySelector('.personalizer__up-price');
      var each = parseInt(input.getAttribute('data-price'), 10) || 0;
      var handle = input.getAttribute('data-handle') || '';
      var n = ctx.state.besties.length;
      if (!ctx.state.upsellPets) ctx.state.upsellPets = {};
      if (!input.checked) {
        if (chips) collapse(chips);
        if (priceEl) priceEl.textContent = money(ctx, each);
        return;
      }
      var sel = (ctx.state.upsellPets[handle] || []).filter(function (i) { return i >= 0 && i < n; });
      // one pet: it can only be for them — no question asked
      if (n === 1) sel = [0];
      ctx.state.upsellPets[handle] = sel;
      if (n === 1) {
        if (chips) collapse(chips);
        if (priceEl) priceEl.textContent = money(ctx, each);
        return;
      }
      var fresh = !chips;
      if (fresh) {
        chips = document.createElement('div');
        chips.className = 'personalizer__up-pets';
        row.parentNode.insertBefore(chips, row.nextSibling);
      }
      // by CHARM, not by pet: two charms of the same pet are common, and
      // "Pet 1 · Luna / Pet 2 · Luna" reads as a mistake
      var unitChip = ctx.config.perPetChipLabel || unitOf(ctx);
      chips.innerHTML = '<span class="personalizer__up-pets-lb">Which ' + esc(unitChip.toLowerCase()) + 's get them? <em>one, some or all</em></span>';
      var allChip = document.createElement('button');
      allChip.type = 'button';
      allChip.className = 'personalizer__pet-chip personalizer__pet-chip--all' + (sel.length === n ? ' personalizer__pet-chip--sel' : '');
      allChip.setAttribute('aria-pressed', sel.length === n ? 'true' : 'false');
      allChip.textContent = 'All ' + n;
      allChip.addEventListener('click', function () {
        var all = []; for (var k = 0; k < n; k++) all.push(k);
        ctx.state.upsellPets[handle] = (sel.length === n) ? [] : all;
        ctx.onStateChange();
      });
      chips.appendChild(allChip);
      for (var i = 0; i < n; i++) {
        (function (idx) {
          var picked = sel.indexOf(idx) !== -1;
          var nm = String(ctx.state.besties[idx].petName || '').trim();
          var chip = document.createElement('button');
          chip.type = 'button';
          chip.className = 'personalizer__pet-chip' + (picked ? ' personalizer__pet-chip--sel' : '');
          chip.setAttribute('aria-pressed', picked ? 'true' : 'false');
          chip.textContent = unitChip + ' ' + (idx + 1) + (nm ? ' · ' + nm : '');
          chip.addEventListener('click', function () {
            var cur = ctx.state.upsellPets[handle] || [];
            var at = cur.indexOf(idx);
            if (at === -1) cur.push(idx); else cur.splice(at, 1);
            ctx.state.upsellPets[handle] = cur;
            ctx.onStateChange(); // empty selection just blocks the step, row stays ticked
          });
          chips.appendChild(chip);
        })(i);
      }
      if (fresh) unfold(chips); else chips.classList.add('pz-unfold', 'is-open');
      if (priceEl) {
        priceEl.textContent = sel.length
          ? money(ctx, each * sel.length) + (sel.length > 1 ? ' (' + sel.length + ')' : '')
          : money(ctx, each);
      }
    });
  }

  /* Note-upsell expansion (config.noteUpsells, e.g. wings on nursery
     mobiles where pets carry no names): while ticked, a free-text input asks
     WHICH pet it's for. Built ONCE per tick and never rebuilt while typing
     (focus survives refreshUI); value lives in state.upsellNotes[handle]. */
  function renderUpsellNotes(ctx) {
    var multi = (ctx.state.besties.length || 1) >= 2;
    ctx.root.querySelectorAll('.personalizer__upsell-input[data-note-upsell]').forEach(function (input) {
      var row = input.closest('.personalizer__up');
      if (!row) return;
      var handle = input.getAttribute('data-handle') || '';
      var holder = holderAfter(row, 'personalizer__up-note');
      if (hideDollAddonRow(ctx, input, row, holder)) return;
      if (!input.checked || !multi) { if (holder) collapse(holder); return; }
      if (holder) return; // already built — rebuilding would eat the caret
      if (!ctx.state.upsellNotes) ctx.state.upsellNotes = {};
      var prompt = (ctx.config.noteUpsellPrompts || {})[handle] || {};
      holder = document.createElement('div');
      holder.className = 'personalizer__up-pets personalizer__up-note';
      var lb = document.createElement('span');
      lb.className = 'personalizer__up-pets-lb';
      lb.textContent = prompt.label || ('Which ' + unitOf(ctx).toLowerCase() + ' is it for?');
      var inp = document.createElement('input');
      inp.type = 'text';
      inp.className = 'personalizer__name-input';
      inp.maxLength = 120;
      inp.placeholder = prompt.placeholder || 'e.g. Luna · the golden retriever';
      inp.value = ctx.state.upsellNotes[handle] || '';
      inp.addEventListener('input', function () {
        ctx.state.upsellNotes[handle] = inp.value;
        if (ctx.onFieldInput) ctx.onFieldInput();
      });
      holder.appendChild(lb);
      holder.appendChild(inp);
      row.parentNode.insertBefore(holder, row.nextSibling);
      unfold(holder);
    });
  }

  /* Photo-pick add-on (config.photoUpsells, e.g. the pet photo charm):
     ticking the row unfolds the photos uploaded on the photos step as thumbs
     — pick one or many, price = each × picked; the first is pre-picked so
     one tap is enough. The chosen photos ride the add-on's own cart line as
     YOUR PHOTO_k (personalizer-cart.js). state.upsellPhotos[handle] = [idx]. */
  function renderUpsellPhotoPick(ctx) {
    var photos = ctx.photoGroup && ctx.photoGroup() ? ctx.photoGroup().getPhotos() : [];
    ctx.root.querySelectorAll('.personalizer__upsell-input[data-photo-pick]').forEach(function (input) {
      var row = input.closest('.personalizer__up');
      if (!row) return;
      var handle = input.getAttribute('data-handle') || '';
      var holder = holderAfter(row, 'personalizer__up-photopick');
      if (hideDollAddonRow(ctx, input, row, holder)) return;
      var priceEl = row.querySelector('.personalizer__up-price');
      var each = parseInt(input.getAttribute('data-price'), 10) || 0;
      if (!ctx.state.upsellPhotos) ctx.state.upsellPhotos = {};
      if (!input.checked) {
        if (holder) collapse(holder);
        if (priceEl) priceEl.textContent = money(ctx, each);
        return;
      }
      var sel = (ctx.state.upsellPhotos[handle] || []).filter(function (i) { return i >= 0 && i < photos.length; });
      if (!sel.length && photos.length && ctx.state.upsellPhotos[handle] === undefined) sel = [0];
      ctx.state.upsellPhotos[handle] = sel;
      var fresh = !holder;
      if (fresh) {
        holder = document.createElement('div');
        holder.className = 'personalizer__up-pets personalizer__up-photopick';
        row.parentNode.insertBefore(holder, row.nextSibling);
      }
      holder.innerHTML = '<span class="personalizer__up-pets-lb">'
        + (photos.length ? 'Which photo do we print? <em>one or more · ' + esc(money(ctx, each)) + ' each</em>' : 'Add photos on the Photos step first')
        + '</span>';
      var grid = document.createElement('div');
      grid.className = 'personalizer__up-photopick__grid';
      photos.forEach(function (p, idx) {
        var on = sel.indexOf(idx) !== -1;
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'personalizer__up-photopick__thumb' + (on ? ' is-on' : '');
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
        b.setAttribute('aria-label', 'Photo ' + (idx + 1));
        b.innerHTML = '<img src="' + esc(p.url) + '" alt="" loading="lazy"><span class="personalizer__up-photopick__tick" aria-hidden="true">✓</span>';
        b.addEventListener('click', function () {
          var cur = ctx.state.upsellPhotos[handle] || [];
          var at = cur.indexOf(idx);
          if (at === -1) cur.push(idx); else cur.splice(at, 1);
          ctx.state.upsellPhotos[handle] = cur;
          ctx.onStateChange();
        });
        grid.appendChild(b);
      });
      holder.appendChild(grid);
      if (fresh) unfold(holder); else holder.classList.add('pz-unfold', 'is-open');
      if (priceEl) {
        priceEl.textContent = sel.length
          ? money(ctx, each * sel.length) + (sel.length > 1 ? ' (' + sel.length + ')' : '')
          : money(ctx, each);
      }
    });
  }

  /* Name-charm add-on (config.nameCharmUpsell): ticking the row unfolds a
     compact block — one pet: colour dots + name; two pets or more: "How
     many?" first, then one colour + name per charm. The checkbox value
     follows the FIRST charm's colour (variant); lines are built per charm in
     personalizer-cart.js. Built ONCE per tick (rebuilding while typing would
     eat the caret) and re-synced on every refresh; the count change rebuilds
     the charm blocks. state.upsellNameCharm = { items: [{ colour, name }] }. */
  function renderUpsellNameCharm(ctx) {
    var cfg = ctx.config.nameCharmUpsell || {};
    var colours = cfg.colours || [];
    var maxLetters = cfg.maxLetters || 8;
    var n = ctx.state.besties.length || 1;
    ctx.root.querySelectorAll('.personalizer__upsell-input[data-name-charm]').forEach(function (input) {
      var row = input.closest('.personalizer__up');
      if (!row) return;
      var holder = holderAfter(row, 'personalizer__up-namecharm');
      if (hideDollAddonRow(ctx, input, row, holder)) return;
      var priceEl = row.querySelector('.personalizer__up-price');
      var each = parseInt(input.getAttribute('data-price-each') || input.getAttribute('data-price'), 10) || 0;
      input.setAttribute('data-price-each', String(each));
      if (!input.checked) {
        if (holder) collapse(holder);
        if (priceEl) priceEl.textContent = money(ctx, each);
        return;
      }
      if (!ctx.state.upsellNameCharm || !ctx.state.upsellNameCharm.items) ctx.state.upsellNameCharm = { items: [] };
      var st = ctx.state.upsellNameCharm;
      if (!st.items.length) st.items = [{ colour: '', name: '' }];
      var maxCount = Math.max(1, n);
      if (st.items.length > maxCount) st.items.length = maxCount;
      var variants = {};
      try { variants = JSON.parse(input.getAttribute('data-variants') || '{}'); } catch (e) { variants = {}; }
      function applyColour() {
        var v = variants[st.items[0].colour];
        if (!v || !v.available) return;
        input.value = String(v.id);
        input.setAttribute('data-variant-id', String(v.id));
        var img = row.querySelector('.personalizer__up-img');
        if (img && v.img) { img.removeAttribute('srcset'); img.src = v.img; }
      }
      function paintPrice() {
        if (!priceEl) return;
        var c = st.items.length;
        priceEl.textContent = money(ctx, each * c) + (c > 1 ? ' (' + c + ')' : '');
      }
      function dotsFor(item, k) {
        var sw = document.createElement('div');
        sw.className = 'personalizer__sw personalizer__up-namecharm__dots';
        sw.setAttribute('role', 'radiogroup');
        sw.setAttribute('aria-label', (cfg.colourLabel || 'Colour') + ' for charm ' + (k + 1));
        colours.forEach(function (c) {
          var v = variants[c.name];
          if (!v || !v.available) return;
          var dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'personalizer__dot' + (item.colour === c.name ? ' personalizer__dot--sel' : '');
          dot.style.background = c.hex;
          dot.setAttribute('role', 'radio');
          dot.setAttribute('aria-checked', item.colour === c.name ? 'true' : 'false');
          dot.setAttribute('aria-label', c.name);
          dot.setAttribute('title', c.name);
          dot.setAttribute('data-colour', c.name);
          dot.addEventListener('click', function () {
            item.colour = c.name;
            applyColour();
            ctx.onStateChange();
          });
          sw.appendChild(dot);
        });
        return sw;
      }
      function blockFor(item, k) {
        var wrap = document.createElement('div');
        wrap.className = 'personalizer__up-namecharm__item';
        wrap.setAttribute('data-item', String(k));
        if (st.items.length > 1) {
          var h = document.createElement('div');
          h.className = 'personalizer__up-namecharm__ttl';
          h.textContent = (cfg.itemLabel || 'Charm') + ' ' + (k + 1);
          wrap.appendChild(h);
        }
        var line1 = document.createElement('div');
        line1.className = 'personalizer__up-namecharm__row';
        var lb = document.createElement('span');
        lb.className = 'personalizer__up-namecharm__lb';
        lb.innerHTML = esc(cfg.colourLabel || 'Colour') + ' <em data-namecharm-echo aria-live="polite">' + esc(item.colour || 'pick one') + '</em>';
        line1.appendChild(lb);
        line1.appendChild(dotsFor(item, k));
        wrap.appendChild(line1);
        var inpId = 'personalizer-namecharm-' + (input.getAttribute('data-handle') || 'name') + '-' + k;
        var line2 = document.createElement('div');
        line2.className = 'personalizer__up-namecharm__row personalizer__up-namecharm__row--name';
        var nl = document.createElement('label');
        nl.className = 'personalizer__up-namecharm__lb';
        nl.setAttribute('for', inpId);
        nl.textContent = cfg.nameLabel || 'Name';
        line2.appendChild(nl);
        var inp = document.createElement('input');
        inp.type = 'text';
        inp.id = inpId;
        inp.className = 'personalizer__name-input personalizer__name-input--caps personalizer__up-namecharm__input';
        inp.maxLength = maxLetters;
        inp.autocomplete = 'off';
        inp.setAttribute('autocapitalize', 'characters');
        inp.placeholder = cfg.namePlaceholder || ('Their name · up to ' + maxLetters + ' letters');
        inp.value = item.name || '';
        inp.addEventListener('input', function () {
          item.name = inp.value.slice(0, maxLetters);
          if (ctx.onFieldInput) ctx.onFieldInput();
        });
        line2.appendChild(inp);
        wrap.appendChild(line2);
        return wrap;
      }
      function paintCount(countEl) {
        countEl.querySelectorAll('.personalizer__pet-chip').forEach(function (c) {
          var on = Number(c.getAttribute('data-count')) === st.items.length;
          c.classList.toggle('personalizer__pet-chip--sel', on);
          c.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
      }
      if (holder) {
        // sync only: dots + echoes follow the state; the count chips too
        holder.querySelectorAll('.personalizer__up-namecharm__item').forEach(function (wrap) {
          var item = st.items[Number(wrap.getAttribute('data-item'))];
          if (!item) return;
          wrap.querySelectorAll('.personalizer__dot').forEach(function (d) {
            var on = d.getAttribute('data-colour') === item.colour;
            d.classList.toggle('personalizer__dot--sel', on);
            d.setAttribute('aria-checked', on ? 'true' : 'false');
          });
          var echo = wrap.querySelector('[data-namecharm-echo]');
          if (echo) echo.textContent = item.colour || 'pick one';
        });
        var countEl = holder.querySelector('[data-namecharm-count]');
        if (countEl) paintCount(countEl);
        // count changed → the item blocks are rebuilt (no field is focused then)
        if (holder.querySelectorAll('.personalizer__up-namecharm__item').length !== st.items.length) {
          var items = holder.querySelector('[data-namecharm-items]');
          if (items) { items.innerHTML = ''; st.items.forEach(function (it, k) { items.appendChild(blockFor(it, k)); }); }
        }
        applyColour();
        paintPrice();
        return;
      }
      holder = document.createElement('div');
      holder.className = 'personalizer__up-namecharm';
      var inner = document.createElement('div');
      inner.className = 'personalizer__up-namecharm__in';
      holder.appendChild(inner);
      if (maxCount > 1) {
        var countRow = document.createElement('div');
        countRow.className = 'personalizer__up-namecharm__row personalizer__up-namecharm__row--count';
        countRow.setAttribute('data-namecharm-count', '');
        var clb = document.createElement('span');
        clb.className = 'personalizer__up-namecharm__lb';
        clb.innerHTML = esc(cfg.countLabel || 'How many?') + ' <em>' + esc(money(ctx, each)) + ' each</em>';
        countRow.appendChild(clb);
        var chipsWrap = document.createElement('div');
        chipsWrap.className = 'personalizer__up-namecharm__count';
        for (var c = 1; c <= maxCount; c++) {
          (function (count) {
            var chip = document.createElement('button');
            chip.type = 'button';
            chip.className = 'personalizer__pet-chip' + (st.items.length === count ? ' personalizer__pet-chip--sel' : '');
            chip.setAttribute('data-count', String(count));
            chip.setAttribute('aria-pressed', st.items.length === count ? 'true' : 'false');
            chip.textContent = String(count);
            chip.addEventListener('click', function () {
              while (st.items.length < count) st.items.push({ colour: '', name: '' });
              st.items.length = count;
              ctx.onStateChange();
            });
            chipsWrap.appendChild(chip);
          })(c);
        }
        countRow.appendChild(chipsWrap);
        inner.appendChild(countRow);
      }
      var itemsEl = document.createElement('div');
      itemsEl.setAttribute('data-namecharm-items', '');
      st.items.forEach(function (it, k) { itemsEl.appendChild(blockFor(it, k)); });
      inner.appendChild(itemsEl);
      if (cfg.hint) {
        var hint = document.createElement('p');
        hint.className = 'personalizer__up-namecharm__hint';
        hint.textContent = cfg.hint;
        inner.appendChild(hint);
      }
      row.parentNode.insertBefore(holder, row.nextSibling);
      applyColour();
      paintPrice();
      requestAnimationFrame(function () { requestAnimationFrame(function () { holder.classList.add('is-open'); }); });
    });
  }

  window.PersonalizerRender.renderOrderType = renderOrderType;
  window.PersonalizerRender.renderTwin = renderTwin;
  window.PersonalizerRender.renderUpsellPets = renderUpsellPets;
  window.PersonalizerRender.renderUpsellNotes = renderUpsellNotes;
  window.PersonalizerRender.renderUpsellNameCharm = renderUpsellNameCharm;
  window.PersonalizerRender.renderUpsellPhotoPick = renderUpsellPhotoPick;
  window.PersonalizerRender.renderAxis = renderAxis;
  window.PersonalizerRender.renderCounts = renderCounts;
  window.PersonalizerRender.renderBagPreview = renderBagPreview;
  window.PersonalizerRender.renderSameSubject = renderSameSubject;
  window.PersonalizerRender.renderPhotoUnits = renderPhotoUnits;
  window.PersonalizerRender.renderCardPreview = renderCardPreview;
  window.PersonalizerRender.renderTypeRows = renderTypeRows;
  window.PersonalizerRender.renderColorRows = renderColorRows;
  window.PersonalizerRender.renderMockups = renderMockups;
  window.PersonalizerRender.renderNames = renderNames;
})();
